import CmsApiService from "@/services/api/cms";
import { type INavMenuItem } from "@/types";
import lookAndFeel from "@/config/lookAndFeel";
import { ref } from "vue";

const FALLBACK_MAIN_ITEMS: INavMenuItem[] = [
  { label: "Startseite", url: "/", isExternal: false },
  { label: "Suche", url: "/search", isExternal: false },
  { label: "Über das Projekt", url: "/about", isExternal: false },
  { label: "Über unsere Quellen", url: "/publishers", isExternal: false },
  { label: "Medium vorschlagen", url: "/suggest", isExternal: false },
];

const FALLBACK_SUPPLEMENTAL_ITEMS: INavMenuItem[] = [
  { label: "Hilfe / FAQs", url: "/faq", isExternal: false },
  { label: "LTI-Schnittstelle", url: "/cms/lti", isExternal: false },
  { label: "Kontakt", url: "/contact", isExternal: false },
];

export const useCmsHeaderConfig = () => {
  const mainItems = ref<INavMenuItem[]>(FALLBACK_MAIN_ITEMS);
  const supplementalItems = ref<INavMenuItem[]>(FALLBACK_SUPPLEMENTAL_ITEMS);
  const logoUrl = ref<string>(lookAndFeel.logoHeaderFileUrl);
  const headerText = ref<string>(lookAndFeel.headerText);

  const fetchHeaderConfig = async () => {
    const result = await CmsApiService.getHeaderConfig();
    if (result?.mainItems?.length) {
      mainItems.value = result.mainItems;
    }

    if (result?.supplementalItems?.length) {
      supplementalItems.value = result.supplementalItems;
    }

    if (result?.logo?.url) {
      logoUrl.value = result.logo.url;
    }

    if (result?.headerText) {
      headerText.value = result.headerText;
    }
  };

  fetchHeaderConfig();

  return { mainItems, supplementalItems, logoUrl, headerText };
};
